
<div class="container" mat-dialog-content>
  <mat-tab-group animationDuration="0ms" backgroundColor="primary">

    <mat-tab label="item">
      <mat-form-field style="width: 250px;" class="mat-form-field-no-padding" appearance="outline">
        <mat-label>Customer</mat-label>
        <input matInput>
      </mat-form-field>
    
      <mat-form-field style="width: 350px;"class="mat-form-field-no-padding" appearance="outline">
        <mat-label>Email</mat-label>
        <input [disabled]="true" matInput>
      </mat-form-field>
    
      <mat-form-field style="width: 200px;" class="mat-form-field-no-padding" appearance="outline">
        <mat-label>Phone</mat-label>
        <input [disabled]="true" matInput>
      </mat-form-field>
    </mat-tab>


    <mat-tab label="Purchases">

    </mat-tab>
  </mat-tab-group>
</div>

<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
